export default __webpack_public_path__ + "static/media/canival_closure.a861fc79.jpeg";